export default __webpack_public_path__ + "static/media/Revolut.dc29a9e7.svg";